module.exports = require('./LicenseAddressChangeApplicationView');
